module.exports = require('./LicenseAddressChangeApplicationView');
